import logo from './logo.svg';
import './App.css';
import 'survey-core/defaultV2.min.css';
import {surveyJson} from "./surveyJson";
import {Model} from 'survey-core';
import {Survey} from "survey-react-ui";
import {useCallback} from "react";

function App() {

  const survey = new Model(surveyJson);
    const alertResults = useCallback((sender) => {
        const results = JSON.stringify(sender.data);
        alert(results);
    }, []);

    survey.onComplete.add(alertResults);

  return (
    <div>
      <Survey model={survey} />;
    </div>
  );
}

export default App;
